// viewport.ts
import { windowSize } from "@adornis/base/client/frontend-helpers/index.js";
import { A } from "@adornis/base/env-info.js";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";
import { BehaviorSubject, combineLatest, merge, Observable, timer } from "rxjs";
import { distinctUntilChanged, map, shareReplay, startWith, tap } from "rxjs/operators";
var setupDone = false;
var initialSetup = () => {
  if (setupDone)
    console.warn("initial viewport setup ran twice, you sure you want this?");
  document.querySelector("html").setAttribute("style", "height: 100vh; height: -webkit-fill-available;");
  if (A.isNative) {
    Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    Keyboard.setScroll({ isDisabled: true });
  }
  setupDone = true;
};
initialSetup();
var getKeyboardListener = (whatToListenTo) => {
  return new Observable((subscriber) => {
    Keyboard.addListener(
      // @ts-ignore this should have all valid overloads, but it picks the wrong one
      whatToListenTo,
      (info) => {
        subscriber.next();
      }
    );
    return () => Keyboard.removeAllListeners();
  });
};
var initialHeight;
var cordovaKeyboardShown = A.isNative && A.isIOS ? merge(
  getKeyboardListener("keyboardDidShow").pipe(map(() => true)),
  getKeyboardListener("keyboardWillShow").pipe(map(() => true)),
  getKeyboardListener("keyboardWillHide").pipe(map(() => false))
).pipe(startWith(false), shareReplay(1)) : merge(
  windowSize,
  timer(500).pipe(tap(() => initialHeight = window.visualViewport?.height ?? window.innerHeight))
).pipe(
  map(() => (window.visualViewport?.height ?? window.innerHeight) !== initialHeight),
  // will only work on Chrome Android
  shareReplay(1)
);
var intrinsicHeight = new BehaviorSubject(0);
combineLatest([windowSize, cordovaKeyboardShown]).pipe(
  map(
    ([_, keyboardShown]) => window.visualViewport ? window.visualViewport.height : A.isIOS && !keyboardShown ? window.screen.height : window.innerHeight
  ),
  distinctUntilChanged(),
  tap(() => !A.isNative && (document.body.parentElement.scrollTop = 0))
).subscribe(intrinsicHeight);
export {
  cordovaKeyboardShown,
  intrinsicHeight
};
